import
  React
from 'react';

import {
  Text,
  VContainerVH
} from '@vodacom/web-common';

import {
  CustomColors
} from '../../constants';

export const GeneralError = props => {

  return (

    <VContainerVH
      margin='20px auto'
      width={'80%'}
      height={'450px'}
      backgroundColor={CustomColors.Grey5}>

      <Text
        fontSize={'16px'}
        padding={'0 15px 16px'}
        color={CustomColors.Grey9}>

        {props.value}
      </Text>

      <Text
        fontSize={'20px'}
        padding={'0 15px 16px'}
        color={CustomColors.Grey11}
        fontWeight={'bold'}
        textAlign={'center'}>

        {'Content unavailable'}
      </Text>

      <Text
        fontSize={'16px'}
        padding={'0 15px'}
        color={CustomColors.Grey9}
        textAlign={'center'}>

        {'There was a problem loading this content please reload the page or try again later.'}
      </Text>
    </VContainerVH>
  );
};